// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 607 ? "vendor-monaco" : chunkId) + "." + {"96":"e7c97c9da894c26b3a51","607":"f5f7e2e99f9b7dd4176d"}[chunkId] + ".hashedasset.js";
};